<template>
  <AtomicUiNotification
    v-if="addOfferNotification || showNotifications?.error"
    :severity="addOfferNotification?.type || 'error'"
    :closable="false"
    class="offerNotification"
  >
    {{ addOfferNotification?.message || showNotifications?.error[0]?.message }}
  </AtomicUiNotification>
  <div class="grid-x cards-container">
    <div v-if="envProps.entryPoint === 'bcom'" class="page-title padding-bottom-s padding-left-xs">
      <h1 class="page-title-text">Sales &amp; Promotions</h1>
    </div>
    <Canvas v-if="pageData?.rows" :canvas="pageData" />
    <AtomicUiSlideout :id="slideoutStack[0]?.id" :title="slideoutStack[0].title" :backable="slideoutStack[0].backable">
      <component :is="slideoutStack[0]?.component" v-if="slideoutStack[0]?.component" v-bind="slideoutStack[0].props" />
    </AtomicUiSlideout>
  </div>
  <SponsoredItems v-if="envProps.entryPoint === 'mcom'" />
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useEnvPropsStore } from '~/stores/envProps';
import Canvas from '../components/canvas/canvas.vue';
import SponsoredItems from '../components/sponsoredItems/SponsoredItems.vue';
import buildCustomerOffersRequestData from '../utils/customerOffers';
import { useLocalStore } from '~/stores/Local';
import { useWalletStore } from '../stores/wallet';

const walletStore = useWalletStore();
const slideoutStack = computed(() => walletStore.slideoutStack);
const localStore = useLocalStore();
const envPropsStore = useEnvPropsStore();
const envProps = computed(() => envPropsStore.envProps);
const pageData = computed(() => localStore?.pageData);
const addOfferNotification = computed(() => walletStore.addOfferNotification);
const showNotifications = computed(() => walletStore?.showNotifications?.errors);

onMounted(() => {
  getUpdatedCustomerOffers();
});

const getUpdatedCustomerOffers = async () => {
  const dataHeaders = buildCustomerOffersRequestData(envProps.value);
  if (dataHeaders) {
    await walletStore.getCustomerOffers(dataHeaders);
  }
};
</script>

<style lang="scss" scoped>
.promotionoffers {
  position: inherit;
}
.cards-columns-container {
  padding: rem-calc(1);
  margin-bottom: rem-calc(6);
}
.promotion-offers {
  background-color: $background-color;
  margin-top: 0.5rem;
}
.my-wallet-home-container {
  .my-wallet-home {
    padding-left: rem-calc(0) !important;
    padding-right: rem-calc(0) !important;
    padding-top: rem-calc(20) !important;
  }
}
.slideout-header {
  color: $black !important;
  background: $gray-5-color !important;
  padding: 5% 6% 5% 6%;
  width: 100%;
}
.slideout {
  padding: rem-calc(0) !important;
}
.grid-x > .small-12 {
  padding: rem-calc(20) !important;
}
@media only screen and (max-width: rem-calc(600)) {
  .my-wallet-home {
    width: 98% !important;
  }

  .my-wallet-home-container {
    width: rem-calc(470) !important;
  }
}
.offerNotification {
  width: 100%;
  margin-bottom: rem-calc(24);
}
</style>
<style lang="scss" brand="mcom" scoped>
.cards-container {
  background-color: #eeeeee;
}
</style>
<style lang="scss" brand="bcom" scoped>
.cards-container {
  font-style: normal;
}
.page-title {
  width: 100%;
}
.page-title-text {
  padding-bottom: 1.42857rem;
  border-bottom: 1px solid #d0d0d0;
  font-size: 1.28571rem;
  line-height: 1.38889;
  margin-top: 0;
}
</style>
